/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import Swal from "sweetalert2";

import NewHolliday from "./NewHolliday";

import { getRequest } from "utils/request";

import { deleteRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { i18n } from '../../../translate/i18n';
import { useModal } from "hooks/modal";
import formatDate from "utils/formatDate";
import exportExcel from "utils/exportExcel";

export default function TabHolliday({ companyData, handleUpdate }) {
  const [holliday, setHolliday] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newHolliday, setNewHolliday] = useState(false);
  const [selectedHolliday, setSelectedHolliday] = useState({});
  const [globalFilter, setGlobalFilter] = useState('');
  const { toggleHelperId } = useModal();

  useEffect(() => {
    const value = JSON.stringify(companyData);

    if (value !== "{}") {
      setLoading(true);
      getRequest(`/holidays?CompanyId=${companyData.id}`)
      .then(function (response) {
          setHolliday(response.data);
          setLoading(false);
        }
      )
    }
  }, []);

  const handleGoBack = () => {
    setNewHolliday(!newHolliday);
  };

  const handleNewHolliday = () => {
    handleUpdate(8);
    setNewHolliday(!newHolliday);
  };

  const handleEditHolliday = (data) => {
    setSelectedHolliday(data);
    setNewHolliday(!newHolliday);
  };

  const handleInativate = (id) => {
    Swal.fire({
      title: i18n.t('attemption'),
      text: i18n.t('deleteHolliday'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t('confirmEraseCompany'),
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRequest(`/holidays/${id}`)
          .then(function (response) {
              handleUpdate(8);
            }
          )
      }
    });
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() =>  handleEditHolliday(data)   }
        >
          <i className="mdi mdi-pencil" style={{fontSize: 20}}></i>
        </div>
        <div
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={() =>  handleInativate(data.id)}
        >
          <i className="mdi mdi-delete" style={{fontSize: 20}}></i>
        </div>
      </div>
    )
  }

  const header = (
    <>
      <div className="data-table-header"
      >
        <i className="pi pi-search" style={{paddingRight: 10}}></i>
        <input 
          className='input-globalfilter' 
          type="search" 
          onChange={(e) => setGlobalFilter(e.target.value)} 
          placeholder="Buscar" 
          icon="pi pi-search"/>

      </div>
    </>
  )

  const dateTemplate = (data) =>  (
    <span>{formatDate(data.date)}</span>
  )

  const handleExport = () => {
    let data = [];

    holliday.forEach(e => {
      const hollidayAux = {
        ID: e.id,
        [i18n.t('date')]: formatDate(e.date),
        [i18n.t('description')]: e.description,
        [i18n.t('createdAt')]: formatDate(e.createdAt)
      }
      data.push(hollidayAux);
    })
    exportExcel(data, i18n.t('holliday'))
  }

  useEffect(() => {
    toggleHelperId(!newHolliday ? 31 : 32)
  }, [newHolliday])

  return (
    <div className="list-container">
      <div className="title-helper-container" style={!newHolliday ? { borderWidth: 0} : {marginBottom: 10}}>
        <h3>{companyData.nickName}</h3>
        {!newHolliday && (
          <button style={{marginBottom: 5}} type="button" onClick={handleExport} className="export-excel" >
            <i style={{fontSize: 16, marginRight: 5}} className="pi pi-file-excel"/>  
            <span style={{fontSize: '1vw'}}>{i18n.t('exportAllData')}</span>
          </button>
        )}
      </div>
      {!newHolliday ? (
        <>
          <div className="tab-content">
            <div className="tab-pane show active" id="multi-item-preview">
              {!loading ? (
                 <DataTable 
                 header={header}
                  globalFilter={globalFilter}
                 dataKey="id"
                 rowsPerPageOptions={[5,10,25,50]} 
                 value={holliday}
                 paginator
                 rows={5} 
                 emptyMessage={i18n.t('noHollidayFinded')}
               >
                   <Column body={dateTemplate} field="date" header={i18n.t('date')}></Column>
                   <Column field="description" header={i18n.t('description')} sortable></Column>
                   <Column body={actionButtonsTemplate} field="action" header={i18n.t('action')}></Column>
               </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
              <div
                className="button-add-relative"
                onClick={() => setNewHolliday(true)}
              >
                <i className="mdi mdi-plus"></i>
              </div>
            </div>
          </div>
        </>
      ) : (
        <NewHolliday
          handleNewHolliday={handleNewHolliday}
          companyId={companyData.id}
          selectedHolliday={selectedHolliday}
          handleGoBack={handleGoBack}
        />
      )}
    </div>
  );
}
